let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("11tIB"), load("ffEVr"), load("1lvsb")]).then(() => parcelRequire('jVNaF'));